import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';
import { Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';

import { useDispatch, useSelector } from 'react-redux';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { dietPlanReducerAction } from 'src/redux/reducers/dietPlan';
import { getDietPlans, updateDietplan } from 'src/api/dietPlan';
import DietPlanForm from 'src/components/dietPlan/DietPlanForm';

const UpdateDietPlan = () => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const { updateDietPlans } = dietPlanReducerAction;
  const { logoutUser } = commonReducerAction;
  const { dietPlanList } = useSelector((state) => state.dietPlan);

  const [dietPlan, setDietPlan] = useState({
    name: '',
    diet: '',
    comments: '',
    prescribed_by: '',
    meals: [],
    _id: ''
  });

  const location = useLocation();
  const _id = location?.pathname?.split('/')?.pop();

  useEffect(() => {
    if (dietPlanList?.length) {
      const dietPlan = dietPlanList.find((dietPlan) => dietPlan?._id === _id);
      if (dietPlan) {
        setDietPlan(dietPlan);
      }
    } else {
      dispatch(startLoading());
      getDietPlans(user, gymId)
        .then((res) => {
          if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
            dispatch(logoutUser());
          if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
            dispatch(updateDietPlans(res.data));
          }
          dispatch(stopLoading());
        })
        .catch((err) => {
          console.log(err);
          dispatch(stopLoading());
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dietPlanList]);

  const history = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>DietPlan | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              // _id: dietPlan?._id,
              name: dietPlan?.name,
              diet: dietPlan?.diet,
              comments: dietPlan?.comments,
              prescribed_by: dietPlan?.prescribed_by,
              meals: dietPlan?.meals
            }}
            enableReinitialize
            validationSchema={CONSTANTS.dietValidationSchema}
            onSubmit={async (values) => {
              values.gym_id = gymId;
              if (values?.meals?.length > 0) {
                values.meals = values?.meals?.map((meal) => ({
                  food: meal?.food,
                  quantity: meal?.quantity,
                  time: meal?.time
                }));
              }
              try {
                dispatch(startLoading());
                const res = await updateDietplan(user, values, dietPlan?._id);
                dispatch(stopLoading());

                const isError = res.status !== 200;
                const message = isError
                  ? res?.message
                  : 'Diet Plan Updated Successfully';
                setSnackbarState({
                  open: true,
                  message: message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  history(CONSTANTS.ROUTES.PRIVATE_ROUTES.DIET_PLAN);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <DietPlanForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.UPDATE_DIET_PLAN}
                isFromUpdateTrainer={true}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default UpdateDietPlan;
